import { useAxios } from "../useAxios"
import { useAuthStore } from "../../../stores/auth/useAuthStore"
import { ILinkedInUserData } from "../../../interfaces/models/user"

export interface IOnboardingData {
    startedExtensionInstallation: boolean,
}

export interface ISaveLinkedProfileData {
    userLinkedInInfo: ILinkedInUserData
}

export const useUserRequest = () => {
    const { sendRequest } = useAxios()
    const { store: { authData: { accessToken } } } = useAuthStore()

    const route = '/user'

    //GET
    const getWorkspaces = () => {
        return sendRequest({
            slug: 'getUserWorkspaces',
            url: `${route}/workspaces`,
            method: 'GET'
        })
    }

    const canDeleteUserAccount = () => {
        return sendRequest({
            slug: 'canDeleteUserAccount',
            url: `${route}/can-delete`,
            method: 'GET',
            displayToast: false
        })
    }

    //POST
    const postOnboardingData = (payload: IOnboardingData) => {
        return sendRequest({
            slug: 'onboardingData',
            url: `${route}/on-boarding-data`,
            method: 'POST',
            payload,
            displayToast: false
        })
    };

    const saveLinkedInData = (payload: ISaveLinkedProfileData, errorClb?: (message?: string) => void) => {
        return sendRequest({
            slug: 'linkedinProfileData',
            url: `${route}/linkedin-profile-data`,
            method: 'POST',
            payload,
            displayToast: false,
            errorClb
        })
    }

    const saveUserPreferences = (payload: any) => {
        return sendRequest({
            slug: 'saveUserPreferences',
            url: `${route}/preferences`,
            method: 'POST',
            payload,
            displayToast: false
        })
    }

    const saveTagsAndNotesSettings = (payload: any) => {
        return sendRequest({
            slug: 'saveTagsAndNotesSettings',
            url: `${route}/tags-and-notes-settings`,
            method: 'POST',
            payload,
            all: true
        })
    }

    const getUserOnboardingTasksState = () => {
        return sendRequest({
            slug: 'getOnboardingTasksState',
            url: `${route}/onboarding-steps`,
            method: 'GET'
        })
    }

    //PATCH
    const updateLastFetchPostsDate = () => {
        console.log('updateLastFetchPostsDate API call - sending PATCH request to:', `${route}/last-fetch-posts-date`);
        const payload = { lastFetchPostsDate: new Date().toISOString() };
        console.log('Request payload:', payload);
        
        return sendRequest({
            slug: 'updateLastFetchPostsDate',
            url: `${route}/last-fetch-posts-date`,
            method: 'PATCH',
            payload,
            displayToast: false,
            all: true
        })
    }

    //DELETE
    const deleteUserAccount = () => {
        return sendRequest({
            slug: 'deleteUser',
            url: `${route}/delete`,
            method: 'DELETE',
            displayToast: false
        })
    }

    return {
        getWorkspaces,
        postOnboardingData,
        saveLinkedInData,
        saveUserPreferences,
        getUserOnboardingTasksState,
        saveTagsAndNotesSettings,
        canDeleteUserAccount,
        deleteUserAccount,
        updateLastFetchPostsDate
    };
}

